var _g, _rect, _path, _path2, _path3, _circle, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGold(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 273,
    height: 81,
    viewBox: "0 0 273 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_26_3539)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 25,
    width: 273,
    height: 56,
    rx: 10,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 79,
    y: 23.2329,
    width: 9,
    height: 82.8592,
    transform: "rotate(-35.5519 79 23.2329)",
    fill: "#F8B42B",
    fillOpacity: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83,
    y: 23.2329,
    width: 9,
    height: 82.8592,
    transform: "rotate(-35.5519 83 23.2329)",
    fill: "#FAC730",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83,
    y: 23.2329,
    width: 180.887,
    height: 184.264,
    transform: "rotate(-35.5519 83 23.2329)",
    fill: "#FAC730"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.566 54.42V55.74C147.566 60.448 144.288 63.308 139.976 63.308C135.136 63.308 131.66 59.744 131.66 55.322C131.66 50.856 135.202 47.292 139.734 47.292C142.682 47.292 145.168 48.744 146.466 50.812L143.474 52.528C142.836 51.516 141.45 50.724 139.712 50.724C137.116 50.724 135.18 52.638 135.18 55.344C135.18 57.962 137.028 59.876 140.02 59.876C142.066 59.876 143.408 58.974 143.958 57.5H139.844V54.42H147.566ZM156.898 63.308C152.476 63.308 148.89 59.832 148.89 55.3C148.89 50.768 152.476 47.292 156.898 47.292C161.32 47.292 164.906 50.768 164.906 55.3C164.906 59.832 161.32 63.308 156.898 63.308ZM156.898 59.876C159.406 59.876 161.386 58.05 161.386 55.3C161.386 52.55 159.406 50.724 156.898 50.724C154.39 50.724 152.41 52.55 152.41 55.3C152.41 58.05 154.39 59.876 156.898 59.876ZM170.408 59.612H175.908V63H166.888V47.6H170.408V59.612ZM183.619 47.6C187.865 47.6 191.099 50.944 191.099 55.3C191.099 59.656 187.865 63 183.619 63H177.459V47.6H183.619ZM183.619 59.612C186.039 59.612 187.711 57.94 187.711 55.3C187.711 52.66 186.039 50.988 183.619 50.988H180.979V59.612H183.619ZM208.918 47.6V50.988H204.958V63H201.438V50.988H197.478V47.6H208.918ZM210.459 47.6H213.979V63H210.459V47.6ZM220.145 59.612H226.305V63H216.625V47.6H226.195V50.988H220.145V53.54H225.645V56.884H220.145V59.612ZM236.387 63L233.483 57.94H231.811V63H228.291V47.6H234.451C237.377 47.6 239.731 49.954 239.731 52.88C239.731 54.772 238.587 56.488 236.893 57.346L240.171 63H236.387ZM231.811 50.9V54.86H234.451C235.419 54.86 236.211 54.002 236.211 52.88C236.211 51.758 235.419 50.9 234.451 50.9H231.811Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_26_3539)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M68.678 51.8253C68.0782 52.2525 64.2297 49.5444 63.4926 49.5385C62.7555 49.5326 58.8637 52.1784 58.2709 51.7416C57.6781 51.3048 59.0717 46.8182 58.8497 46.1173C58.6276 45.4165 54.9014 42.5433 55.1348 41.8461C55.3682 41.1489 60.0781 41.0842 60.6778 40.657C61.2776 40.2298 62.8666 35.8082 63.6037 35.8141C64.3407 35.82 65.8579 40.2666 66.4507 40.7034C67.0435 41.1402 71.7517 41.2808 71.9738 41.9816C72.1959 42.6824 68.4238 45.4953 68.1903 46.1925C67.9569 46.8897 69.2778 51.3981 68.678 51.8253Z",
    fill: "url(#paint0_linear_26_3539)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.678 51.8253C68.0782 52.2525 64.2297 49.5444 63.4926 49.5385C62.7555 49.5326 58.8637 52.1784 58.2709 51.7416C57.6781 51.3048 59.0717 46.8182 58.8497 46.1173C58.6276 45.4165 54.9014 42.5433 55.1348 41.8461C55.3682 41.1489 60.0781 41.0842 60.6778 40.657C61.2776 40.2298 62.8666 35.8082 63.6037 35.8141C64.3407 35.82 65.8579 40.2666 66.4507 40.7034C67.0435 41.1402 71.7517 41.2808 71.9738 41.9816C72.1959 42.6824 68.4238 45.4953 68.1903 46.1925C67.9569 46.8897 69.2778 51.3981 68.678 51.8253Z",
    fill: "url(#paint1_linear_26_3539)"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 25.25,
    width: 272.5,
    height: 55.5,
    rx: 9.75,
    stroke: "url(#paint2_linear_26_3539)",
    strokeWidth: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.31,
    d: "M51.2171 53.5815L44.2137 50.1912L36.3102 59.6166L34.9832 57.7327L36.635 45.0624L30.0926 25.3701L15.0991 30.6783L19.0926 40.7317L31.9269 71.6281L34.7574 78.6283L35.0852 76.596L38.2126 64.6711L42.5835 59.8177L50.388 59.2176L37.959 50.615L51.2171 53.5815Z",
    fill: "#010101",
    fillOpacity: 0.3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.1439 16.5047C43.7805 16.5047 47.5392 12.8776 47.5392 8.40324C47.5392 3.92892 43.7805 0.301758 39.1439 0.301758C34.5073 0.301758 30.7485 3.92892 30.7485 8.40324C30.7485 12.8776 34.5073 16.5047 39.1439 16.5047Z",
    fill: "#C2C2C2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M61.3015 65.3083L56.1944 67.8726C54.7095 65.0484 51.5605 63.1769 47.9939 63.4615C43.8209 63.7956 40.4925 67.1519 40.3193 71.1887C40.2543 72.6952 40.6131 74.1181 41.2999 75.3493L40.9534 75.5225L38.2251 76.8898L34.7605 78.6282C32.9726 74.5914 31.4599 70.5391 30.1824 66.5394C29.9751 65.8991 29.774 65.2526 29.5823 64.6123V64.6061C29.44 64.1359 29.2977 63.6533 29.1894 63.279C29.0811 62.9078 29.0069 62.6511 29.0069 62.6511C26.7147 54.6548 25.3134 46.9863 24.472 40.2583L24.4782 40.3882C23.3584 33.0044 23.3027 24.9648 23.3027 24.9648C23.2656 23.6285 23.2563 22.419 23.2563 21.3517C23.2563 20.7052 23.2564 20.1082 23.2687 19.57C23.3028 17.4294 23.3801 16.1642 23.3894 15.9848V15.9631L27.8624 16.5694L30.1205 16.9468C30.105 17.1448 30.0958 17.3459 30.0958 17.5469C30.0958 22.023 33.8542 25.6484 38.488 25.6484C42.3547 25.6484 45.6058 23.1304 46.5802 19.6999L48.993 20.102L52.6741 20.7485V20.764C52.6648 20.8908 52.5659 22.6974 52.5782 25.602C52.5782 25.602 52.7917 33.7932 53.1381 36.9546C53.5743 41.4369 54.3105 46.4017 55.5571 51.2552C55.5633 51.2706 55.5664 51.283 55.5695 51.2985C56.0397 53.2071 56.1046 53.2658 56.1077 53.2658C57.3575 57.5872 59.0402 61.7447 61.3046 65.3052L61.3015 65.3083Z",
    fill: "#F8B42B"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 63.2274,
    cy: 44.6554,
    r: 13.9054,
    stroke: "url(#paint3_linear_26_3539)",
    strokeWidth: 0.5
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_26_3539",
    x1: 55.1243,
    y1: 43.8426,
    x2: 71.9833,
    y2: 43.8426,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#474747"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BEBEBE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_26_3539",
    x1: 55.1243,
    y1: 43.8426,
    x2: 71.9833,
    y2: 43.8426,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCD635"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7A928"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_26_3539",
    x1: 0.000001017,
    y1: 53,
    x2: 136.5,
    y2: 81,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA619"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_26_3539",
    x1: 63.2274,
    y1: 30.5,
    x2: 63.2274,
    y2: 58.8108,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8B32B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#99907D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_26_3539"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 25,
    width: 273,
    height: 56,
    rx: 10,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_26_3539"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(54 35)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGold);
export default __webpack_public_path__ + "static/media/Gold.c412843cfebe20afa314a2e26093c218.svg";
export { ForwardRef as ReactComponent };